<template>
  <div>
    <book :book="featured" v-once />

    <div
      class="divider d-flex align-items-center my-3 py-3"
      @click="scrollBottom"
    >
      <div class="divider__line"></div>
      <div class="divider__text ml-3 mr-2">Weitere Bücher</div>
      <span class="divider__arrow mr-3">&#187;</span>
      <div class="divider__line"></div>
    </div>

    <div class="other-books pt-2" ref="otherBooks">
      <book v-for="book in otherBooks" v-once :key="book.title" :book="book" />
    </div>
  </div>
</template>
<style lang="scss" scoped>
@import "~@/scss/mixins";

.divider {
  cursor: pointer;
  opacity: 0.5;
  transition: all 0.1s ease-out;

  &:hover {
    opacity: 0.8;
  }

  &:hover &__text {
    text-decoration: underline;
  }

  &__line {
    flex-grow: 1;
    height: 1px;
    background: #333;
    opacity: 0.5;
  }

  &__arrow {
    transition: all 0.1s ease-out;
    transform-origin: center;
    transform: rotate(90deg);
  }
}
.other-books .book:not(:last-child) {
  border-bottom: 1px solid $gray-300;
  padding-bottom: $spacer * 2;
  margin-bottom: $spacer * 3;
  @include media-breakpoint-up(md) {
    padding-bottom: $spacer * 3;
    margin-bottom: $spacer * 4;
  }
}
</style>
<script>
import Book from "@/components/Book";
import books from "@/content/books";

export default {
  components: {
    Book
  },
  data: () => ({
    books
  }),
  computed: {
    featured() {
      return this.books[0];
    },
    otherBooks() {
      return this.books.slice(1);
    }
  },
  methods: {
    scrollBottom() {
      this.$refs.otherBooks.scrollIntoView({
        behavior: "smooth"
      });
    }
  }
};
</script>
